import { ActionPlansTab } from '@features/action-plans/components/ActionPlansTab'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/action-plans/')({
    component: RouteComponent,
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <ActionPlansTab studentNo={studentNo} />
    )
}